import { GdPlatformCorrectionsWebInput } from './graphql-grid';

export interface PredictorData {
    isLoading: boolean;
    isLoadingRecommendation: boolean;
    recommendationError?: string;
    detailed?: ReachResultValue;
    basic?: ReachResultValue;
    id?: string;
    bannerFormats?: BannerFormats[];
    error?: string;
    isExpanderOpened: boolean;
    banners?: BannerSize[];
    otsBasic?: ReachResultValue;
    otsDetailed?: ReachResultValue;
}

export interface PlatformType {
    value: GdPlatformCorrectionsWebInput;
    empty: boolean;
}

export interface BannerSize {
    height?: string;
    width?: string;
    isAdaptive?: boolean;
    isAspect?: boolean;
}

export interface BannerFormats {
    format: string;
    increasePercent: number;
}

export interface PredictorGeo {
    ids: number[] | null;
    text: string;
}

export interface TextPredictor {
    title: string;
    value: string[] | string;
}

export enum StatusReach {
    NORMAL = 'normal',
    LESS = 'less',
    EMPTY = 'empty'
}

export interface ReachResultValue {
    value?: number;
    status: StatusReach;
}

export interface UpdateDataReach {
    groupId: string;
    reqId: string;
    basic?: ReachResultValue;
    detailed?: ReachResultValue;
    otsBasic?: ReachResultValue;
    otsDetailed?: ReachResultValue;
}

export interface UpdateDataReachOutdoor {
    groupId: string;
    reqId: string;
    basic?: ReachResultValue;
    detailed?: ReachResultValue;
}

export interface OutdoorData {
    region: string[];
    facility: string[];
    operatorName: string[];
    screensCount: number;
}

export interface IndoorData {
    region: string[];
    facility: string[];
    zone: string[];
    screensCount: number;
}
